module.exports = __webpack_public_path__ + "img/icons BFr_34.d30bfd39.png";